<div class="flex justify-center mt-2 mb-6"
  *ngIf="meeting">
  <div class="flex-col">
    <div class="w-343 tablet:w-768 laptop:w-912 tablet:px-6">
      <div class="bg-light rounded border-l-6 border-error-400 shadow-mdlight mobile:p-6 tablet:p-8 w-full">
        <div class="tablet:flex tablet:items-center tablet:justify-between">
          <p class="text-4 font-medium text-dark leading-24 mobile:mb-3 tablet:mb-0">{{dashboardInfo?.jobTitle}}</p>
          <span class="inline-table tablet:flex tablet:items-center px-5 border border-error-200 bg-error-50 rounded-[37px]">
            <span class="text-error-600 text-[13px] leading-[30px]">{{meeting.status == 'cancelled' ? 'Interview Cancelled' : 'Interview Declined'}}</span>
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
